//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  title: 'tax',
  data: function data() {
    return {
      tableData: []
    };
  }
};